import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionsApi } from "../../shared/api/PermissionsApi";

export interface Permission {
  id: number;
  name: string;
}

export type PermissionsResponse = Permission[];

interface PermissionsState {
  roles: PermissionsResponse;
}

const initialState: PermissionsState = {
  roles: [],
};

export const PermissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      PermissionsApi.endpoints.getRoles.matchFulfilled,
      (state, action: PayloadAction<PermissionsResponse>) => {
        state.roles = action.payload;
      }
    );
  },
});

export default PermissionsSlice.reducer;